import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Link, Button } from '@mui/material';
import { convertEpochTime, getUrl, getEndpoint, setCmsSeoData, ExtractAGAU, isCSR, getSlideShowAd} from "../../common/utils";
import { PAGEBUILDER_URLS } from "../Common/Constant.js";
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';
import './slideShow.css'
import Slide from "./Slide";
import { SocialShare } from '../SocialShare/SocialShare';
import { URL_PROTOCAL } from '../Common/Constant';
import bcrypt from 'bcryptjs-react';

var title = "Bengali concerns, tribal hopes, and a three-way race: The essential Tripura";
var authorName = "Bharat Bhushan Verma";
var authorLink = "";
var articlePublishDate = "Updated: Jun 6, 2023, 09:53 IST";
var articleSummary = "The BJP is banking on its governance record while the Left Front and the Congress will be hoping that their alliance will be enough to stop the in its tracks. But in the mix is Pradyot Debbarma’s.";
var heroImageAlt = "Article Show Hero Image";
var imageCreditTxt = "Google";
var bodyContent = "Five years after the BJP ended the Left’s uninterrupted 25-year run in Tripura, the state is set for a three-cornered fight in the Assembly polls on Thursday, with the CPI(M)-Congress combine and the TIPRA Motha challenging the incumbent’s bid to retain power. Five years after the BJP ended the Left’s uninterrupted 25-year run in Tripura, the state is set for a three-cornered fight in the Assembly polls on Thursday, with the CPI(M)-Congress combine and the TIPRA Motha challenging the incumbent’s bid to retain power.";

SlideShow.version = 1000;

SlideShow.lang = 'en';
SlideShow.langs = [
    'en'
];
SlideShow.setLang = (lang) => {
    SlideShow.lang = lang;
}

Object.defineProperty(SlideShow, 'name', {
    writable: true,
    value: 'SlideShow'
});

export function SlideShow(props) {
    const { showImageCredits, showAdSlot, imagecroptype } = props;
    const [view, setView] = useState(false);
    const [slideShowParentData, setSlideShowParentData] = useState([]);
    const [slideShowData, setSlideShowData] = useState([]);
    const { showAuthor, showNewsAgency, showDateTime, showViewport } = props;
    const [seoPageData, setSeoPageData] = useState({});

    var { imagesInViewport } = props;

    const endpoint = getEndpoint(props, "MAIN");
    const seoEndpoint = getEndpoint(props, "SEO_URL");
    const containerEndpoint = ExtractAGAU(props?.data)

    let REQUEST_HOSTNAME = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }

    let REQUEST_URL = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
        if( seoPageData && seoPageData.it && seoPageData.it.primeId ) {
            isLoggedIn();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.gpEditor) {

            window.gpEditor.editor.on('component:selected', (component) => {
                if (component && component.attributes && component.attributes.type === "Slide Show") {
                    setTimeout(() => {
                        const trait = component.getTraits().find((tr) => tr.get('id') === "deviceType");
                        if (trait && trait.el) {
                            // Show trait element if showAdSlot is true, hide otherwise
                            trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                        }
                    }, 200);
                }
            });

            const selected = window.gpEditor.getSelected();
            if (selected) {
                const trait = selected.getTraits().find((tr) => tr.get('id') === "deviceType");
                if (trait && trait.el) {
                    // Show trait element if showAdSlot is true, hide otherwise
                    trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                }
            }
        }
    }, [endpoint, props.showAdSlot, props.adSize]);
    

    const addExportedData = (endpoint) => {
        // if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
        //     && endpoint.SSRDataObj.parentItems.id != null && endpoint.SSRDataObj.parentItems.id != "") {
        //     props.exportedKeys.pid = endpoint.SSRDataObj.parentItems.id;
        // }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && endpoint.SSRDataObj.parentItems.auId != null && endpoint.SSRDataObj.parentItems.auId != "") {
            props.exportedKeys.authorid = endpoint.SSRDataObj.parentItems.auId;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && endpoint.SSRDataObj.parentItems.kws != null && endpoint.SSRDataObj.parentItems.kws != "") {
            props.exportedKeys.tags = endpoint.SSRDataObj.parentItems.kws;
        }
    }

    const addExportedData2 = (item) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && item && item.pid != null && item.pid != "") {
            props.exportedKeys.pid = item.pid;
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj
        && Object.keys(slideShowData).length === 0 && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length > 0) {
        setSlideShowData(endpoint.SSRDataObj.items);
        setSlideShowParentData(endpoint.SSRDataObj.parentItems);
        addExportedData(endpoint);
        // setCmsSeoData(props, endpoint.SSRDataObj.items[0], "SlideShow");

        if (seoEndpoint !== undefined && seoEndpoint && seoEndpoint.isSSR && seoEndpoint.SSRDataObj
            && seoPageData && Object.keys(seoPageData).length === 0 && seoEndpoint.SSRDataObj.items && seoEndpoint.SSRDataObj.items.length > 0) {
            setCmsSeoData(props, seoEndpoint.SSRDataObj.items[0], "SlideShow", endpoint.SSRDataObj.items);
            setSeoPageData(seoEndpoint.SSRDataObj.items[0]);
            addExportedData2(seoEndpoint.SSRDataObj.items[0]);
        }
    } else {
        if (seoEndpoint !== undefined && seoEndpoint && seoEndpoint.isSSR && seoEndpoint.SSRDataObj
            && seoPageData && Object.keys(seoPageData).length === 0 && seoEndpoint.SSRDataObj.items && seoEndpoint.SSRDataObj.items.length > 0) {
            setCmsSeoData(props, seoEndpoint.SSRDataObj.items[0], "SlideShow");
            setSeoPageData(seoEndpoint.SSRDataObj.items[0]);
            addExportedData2(seoEndpoint.SSRDataObj.items[0]);
        }
    }

    const handleChange = () => {
        setView(!view);
    };

    const fetchComponentData = () => {
        let cardUrl = getUrl(props);

        let headerString = '?' + cardUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(cardUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setSlideShowData(val.items)
                setSlideShowParentData(val.parentItems)
                addExportedData(val);
                // setCmsSeoData(props, val.items[0], "SlideShow");
            })
    }
    const showCredits = () => {
        let creditComponent = []
        const authorLink = slideShowParentData?.au && slideShowParentData?.auId
            ? `<a href="/${slideShowParentData.au.replace(/\s+/g, '-')}/author/${slideShowParentData.auId}.html">${slideShowParentData.au}</a>`
            : '';
        if (props.showAuthor && authorLink) {
            creditComponent.push(authorLink);
        }
        if (props.showNewsAgency && containerEndpoint[0]?.ag && containerEndpoint[0]?.ag.length != 0) {
            creditComponent.push(containerEndpoint[0]?.ag)
        }
        let formattedDate = '';
        formattedDate = convertEpochTime(slideShowData[0]?.upd, 'updated', 'MM-dd-yy h:mm a')
        if (formattedDate && props.showDateTime) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='themeonearticalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }

    const getSlideShowList = () => {
        let bodySnippet;
        if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
            let resolution = `781 X 165`;
            if ((window).gpEditor && (window).gpEditor.getDevice() === 'Mobile portrait') {
                resolution = `330 X 83`;
            }
            bodySnippet = `<div class="container" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #f0f0f0;"><div class="ad-box" style="height:165px;display: flex;align-items: center;justify-content: center;">Ad Slot<br>${resolution}</div></div>`
        }
        else if (isCSR()) {
            console.log("Only CSR");
            bodySnippet = props?.data?.attributes?.adConfigurations
        }
        else {
            console.log("Only SSR");
            bodySnippet = props?.data?.attributes?.adConfigurations
        }

        var isViewport = false;
        if (!showViewport) { imagesInViewport = 0; }
        else {
            if (typeof imagesInViewport === 'string' && imagesInViewport.toUpperCase() === "ALL") {
                imagesInViewport = slideShowData.length;
            } else if (typeof imagesInViewport === 'string' && !isNaN(parseInt(imagesInViewport))) {
                imagesInViewport = parseInt(imagesInViewport);
            } else { imagesInViewport = 0; }
        }

        // let resultArr = slideShowData.map((item, index) => {
        //     if (imagesInViewport > index) isViewport = true;
        //     else isViewport = false;
        //     return <Slide item={item} maxlength={slideShowData.length} currentIndex={index + 1} showNewsAgency={showNewsAgency} CONSTANTS={props.CONSTANTS} isViewport={isViewport} showImageCredits={showImageCredits}/>
        // })

        let resultArr = [];
        slideShowData.forEach((item, index) => {
            if (imagesInViewport > index) isViewport = true;
            else isViewport = false;
            
            resultArr.push(<Slide item={item} maxlength={slideShowData.length} currentIndex={index + 1} showNewsAgency={showNewsAgency} CONSTANTS={props.CONSTANTS} isViewport={isViewport} showImageCredits={showImageCredits} imagecroptype = {props.imagecroptype} />);
            
            if (showAdSlot && bodySnippet) {
                resultArr = getSlideShowAd(resultArr, index, bodySnippet, "Slide Show");
            }
        });
        if (showAdSlot && bodySnippet) {
            resultArr = getSlideShowAd(resultArr, -2, bodySnippet, "Slide Show");
        }

        return resultArr;
    }

    return (
        <React.Fragment>
            <h1 className="story-heading">
                {slideShowData.length && slideShowData[0].secName}
            </h1>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container direction='row'>
                    <Grid item xs={12}>
                        <div className="storyshow-subhead slideshowwrap">
                            {showCredits()}
                            <div className='articalmedia slideshowsocial'>
                                <div className='slideshowsocial'>
                                    {
                                        <SocialShare shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL} shareText={slideShowData.length && slideShowData[0].secName} />
                                    }
                                </div>
                            </div>


                        </div>
                    </Grid>
                </Grid>


                <Grid spacing={2}>
                    <Grid item md={12} className='story-details'>
                        <div className='story-wrapper'>
                            {slideShowParentData.parentSyn && <div className='story-wrapper-inner'>
                                <span className='story-wrapper-inner' dangerouslySetInnerHTML={{ __html: slideShowParentData.parentSyn }} />
                            </div>}
                            <div className="card-box header-box">
                                {slideShowData.length && getSlideShowList()}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );

}